import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function addUpdateAssetForm(reqData) {
  try {
    const res = await post(`${URL.addUpdateAssetForm}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
